import {FC} from 'react'

type Props = {
  data: number
}

const CDRTalkDuration: FC<Props> = ({data}) => {
  function formatTime(seconds: number): string {
    const hrs = Math.floor(seconds / 3600)
    const mins = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    const hh = String(hrs).padStart(2, '0')
    const mm = String(mins).padStart(2, '0')
    const ss = String(secs).padStart(2, '0')

    if (hrs > 0) {
      return `${hh}:${mm}:${ss}`
    }
    return `${mm}:${ss}`
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>{formatTime(data)}</div>
    </div>
  )
}

export {CDRTalkDuration}
